import { useEffect, useState } from "react";
import AccountLayout from "../../blocs/AccountLayout";
import { getMyEtablissement } from "../../store/slices/etablissementSlice";
import { useDispatch, useSelector } from "react-redux";
import { create, get } from "../../services/services";
import PlanCard from "../prestataires/planCard";
import { toast } from "react-toastify";
import ListPaymentPlans from "./HistoricPaymentPlan";

// Sous-composant pour le plan actuel
const CurrentPlan = ({ subscription }) => {
  // console.log({subscription})
  const dispatch=useDispatch()
  const resetPlan = () => {
    create({}, `subscriptions/cancel-active`)
      .then((res) => {
        // console.log(res?.data);
        toast.success(res?.data?.message);
        dispatch(getMyEtablissement());
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  return (
    <div className="intervention mt-16 pb-8">
      <p className="body bold500">
        {subscription?.status === "free"
          ? "Plan liberté"
          : `Plan ${subscription?.duration_in_months} mois`}
      </p>
      <div className="row mt-8">
        <div className="col-md-4">
          {(subscription?.status !== "free" && subscription) ? (
            <h2 className="grey500">
              {(
                (subscription?.plan_price_eur /
                100 )/
                subscription?.duration_in_months
              ).toFixed(2)}
              € <span className="body grey66">/mois</span>
            </h2>
          ) : (
            <h2 className="grey500">0€</h2>
          )}
          {subscription?.status === "free" ? (
            <p className="body grey66">
              Seulement{" "}
              <span className="body bold500 grey500">3% de commission </span>
              par rendez-vous
            </p>
          ) : (
            <>
              <p className="body grey66">
                Les {subscription?.duration_in_months} premiers mois puis{" "}
                {subscription?.default_price_eur /
                  subscription?.duration_in_months}
                €/mois
              </p>
              <div className="mt-16">
                <p className="body">
                  <img src="/images/calendar-start.svg" alt="calendar icon" />{" "}
                  Plan souscrit le{" "}
                  {new Date(
                    subscription?.current_period_start
                  )?.toLocaleDateString("fr-FR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  //  timeZone: "Europe/Paris",
                  })}
                </p>{" "}
                <p className="body mt-8">
                  <img src="/images/calendar-fin.svg" alt="calendar icon" />{" "}
                  Prend fin le{" "}
                  {new Date(
                    subscription?.current_period_end
                  )?.toLocaleDateString("fr-FR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  //  timeZone: "Europe/Paris",
                  })}
                </p>
               {subscription?.ends_at &&
                <p className="body mt-8">
                  Annulation du plan prise en compte le {new Date(
                    subscription?.user_canceled_at
                  )?.toLocaleDateString("fr-FR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  //  timeZone: "Europe/Paris",
                  })} {" "}et fin prévu le {new Date(
                    subscription?.ends_at
                  )?.toLocaleDateString("fr-FR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  //  timeZone: "Europe/Paris",
                  })}
                  
                </p>
                }
              </div>
            </>
          )}
        </div>
        <div className="col-md-4">
          {subscription?.status !== "free" && (
            <div className="d-flex mt-24">
              <img src="/images/check-01.svg" alt="check" />
              <span className="text-body-card">Aucune commission</span>
            </div>
          )}
          <PlanFeature text="Accès illimité" />
          <PlanFeature text="Frais de gestion compris" />
          <PlanFeature text="Frais de traitement bancaire gratuits" />
        </div>
        <div className="col-md-4 d-flex align-items-end">
        {(subscription?.status  !== "free" && !subscription?.ends_at )?
         ( <button className="cta bold500" onClick={resetPlan}>
            Annuler la reconduction d'abonnement
          </button>):''
}
        </div>
      </div>
    </div>
  );
};

// Sous-composant pour les features du plan (réutilisable)
const PlanFeature = ({ text }) => {
  return (
    <div className="d-flex">
      <img src="/images/check-01.svg" alt="check" />
      <span className="text-body-card">{text}</span>
    </div>
  );
};

// Sous-composant pour le plan liberté
const FreePlanCard = ({ onSelect }) => {
  return (
    <div className="col-md-4 padding-8  d-flex">
      <div className="card-border">
        <div className="card-padding" style={{ paddingTop: "24px" }}>
          <h4 className="card-title mb-24">Plan liberté</h4>
          <h2 className="card-price">0€</h2>
          <p className="col card-text">
            Seulement 3% de commission par rendez-vous
          </p>
          <PlanFeature text="Sans engagement" />
          <PlanFeature text="Accès illimité" />
          <PlanFeature text="Frais de gestion compris" />
        </div>
        <button
          type="button"
          className="twyny-cta-secondary card-button"
          onClick={onSelect}
        >
          Commencer gratuitement
        </button>
      </div>
    </div>
  );
};

// Composant principal
const MonPlan = () => {
  const dispatch = useDispatch();
  const { selectedEtablissement } = useSelector(
    (state) => state.etablissements
  );
  const [plans, setPlans] = useState([]);
  const [historic, setHistoric] = useState([]);

  useEffect(() => {
    get("subscriptions")
      .then((res) => {
        const filteredPlans = res?.data.filter(
          (plan) =>
            plan.id !== selectedEtablissement?.subscription.plan_id &&
            (plan?.duration_in_months >
              selectedEtablissement?.subscription?.duration_in_months )
        );
        setPlans(filteredPlans);
      })
      .catch(console.log);
  }, [selectedEtablissement?.subscription]);

  useEffect(() => {
    dispatch(getMyEtablissement());
  }, [dispatch]);
  const resetPlan = () => {
    create({}, `subscriptions/cancel-active`)
      .then((res) => {
        // console.log(res?.data);
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  const listFacturePlans = async () => {
  
       get(`user/invoices`)
      //  get(`subscriptions/${selectedEtablissement?.subscription.subscription_id}/invoices`)
       .then((res)=>{
        // console.log(res)
        if(res?.data?.length>0){
          setHistoric(res?.data)
        }
       
        
       // window.open(res?.data[0]?.download_url+'?token='+localStorage.getItem('token'), '_blank');
       })
       .catch((err)=>{
        // console.log(err)
        toast.warning(err?.response?.data?.message)
       })
  

  };
  return (
    <AccountLayout >
      {historic?.length>0?
      <div className="card-twy">
      <ListPaymentPlans payment={historic} setHistoric={setHistoric}/>
      </div>
      :
      <div className="card-twy">
        <h3 className="pd-bt-28">Mon plan forfaitaire</h3>
        <div className="d-flex justify-content-between align-items-end">
          <h4 className="grey500">Mon plan actuel</h4>
          <button className="twyny-cta-secondary" onClick={listFacturePlans}>Voir mes factures</button>
        </div>

      {selectedEtablissement && <CurrentPlan subscription={selectedEtablissement?.subscription} /> } 

      {plans?.length>0 && <h4 className="grey500 mt-8">Découvrir les autres plans</h4>}
        <div className="row align-items-stretch mt-24">
          {/* {selectedEtablissement?.subscription?.status !== "free" && (
            <FreePlanCard onSelect={resetPlan} />
          )} */}
          {plans.map((plan) => (
            <PlanCard
              key={plan.id}
              plan={plan}
              from="account"
              
              free={selectedEtablissement?.subscription?.status === "free"}
              className="col-md-4 padding-8 flex-grow-1 d-flex"
            />
          ))}
        </div>
      </div>}
    </AccountLayout>
  );
};

export default MonPlan;
